import React from 'react';
import { bookData } from '../data/mockData';
import { Lightbulb, Shield, Users, MessageSquare, Award, Briefcase } from 'lucide-react';

const icons = [Lightbulb, Shield, Users, MessageSquare, Award, Briefcase];

const BenefitsSection = () => {
  return (
    <section id="benefits" className="py-24 lg:py-32 bg-[#1a1c1b]">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="mb-6 inline-block">
            <span className="caption text-[#d9fb06] bg-[#3f4816] px-4 py-2 rounded-full">
              QUÉ APRENDERÁS
            </span>
          </div>
          
          <h2 className="heading-2 text-[#d9fb06] mb-6">
            Transforma tu Carrera con Conocimiento Aplicable
          </h2>
          
          <p className="body-medium text-[#888680]">
            Cada capítulo está diseñado para darte herramientas concretas que 
            puedes aplicar inmediatamente en tu desarrollo profesional.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {bookData.benefits.map((benefit, index) => {
            const Icon = icons[index];
            return (
              <div
                key={index}
                className="group relative bg-[#302f2c] border border-[#3f4816] rounded-lg p-6 hover:border-[#d9fb06] transition-all duration-300"
              >
                {/* Icon */}
                <div className="mb-4">
                  <div className="w-12 h-12 rounded-lg bg-[#3f4816] group-hover:bg-[#d9fb06] flex items-center justify-center transition-colors duration-300">
                    <Icon className="text-[#d9fb06] group-hover:text-[#1a1c1b]" size={24} />
                  </div>
                </div>

                {/* Content */}
                <h3 className="heading-6 text-[#d9fb06] mb-3">
                  {benefit.title}
                </h3>
                <p className="body-small text-[#888680] group-hover:text-[#dfddd6] transition-colors">
                  {benefit.description}
                </p>

                {/* Hover effect line */}
                <div className="absolute bottom-0 left-0 w-0 h-1 bg-[#d9fb06] group-hover:w-full transition-all duration-300"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
